import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintPenyerahanData = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocPenyerahanData = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            padding: "5px 0",
            textDecoration: "underline",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          <div>SURAT PERNYATAAN PENYERAHAN DATA</div>
        </div>
        <div style={{ padding: "10px" }}>
          <span>Saya yang bertanda tangan dibawah ini :</span>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td>Tempat/Tgl Lahir</td>
                <td>:</td>
                <td>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? "-"}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td>:</td>
                <td>{""}</td>
              </tr>
              <tr>
                <td>NIK</td>
                <td>:</td>
                <td>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat Domisili</td>
                <td style={{ verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl?.address ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat Sesuai KTP</td>
                <td style={{ verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl?.address ?? "-"}</td>
              </tr>
              <tr>
                <td>Nomor Telp/HP</td>
                <td>:</td>
                <td>{item.sls_appl?.phone ?? "-"}</td>
              </tr>
              <tr>
                <td>Alamat Email</td>
                <td>:</td>
                <td>{item.sls_appl?.email ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div>Selaku Pemohon</div>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td>Tempat/Tgl Lahir</td>
                <td>:</td>
                <td>
                  {item.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(item.sls_appl?.birthat_spouse) ?? "-"}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td>:</td>
                <td>{item.sls_appl?.job_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td>NIK</td>
                <td>:</td>
                <td>{item.sls_appl?.identity_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat Domisili</td>
                <td style={{ verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl?.address_spouse ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div>Selaku suami/istri pemohon</div>

          <div style={{ marginTop: "15px" }}>Bersama ini ;</div>
          <p>Menyatakan telah mengetahui, memahami dan menyanggupi untuk memenuhi seluruh ketentuan dan persyaratan Pusat Pengelolaan Dana Pembiayaan Perumahan (PPDPP) untuk mendapatkan fasilitas KPR Sejahtera.</p>
          <p>Menyampaikan semua data pribadi (KTP, NPWP, Pas Photo) untuk mendapatkan fasilitas KPR Sejahtera dan semua data lainnya yang diperlukan oleh PPDPP melalui Bank BTN, serta menjamin bahwa semua data yang saya sampaikan tersebut adalah benar dan dapat dipertanggung jawabkan keabsahannya.</p>
          <p>Memberikan kuasa PPDPP untuk mengakses semua data pribadi saya yang terkait data FLPP yang ada di Bank BTN. Apabila dikemudian hari pernyataan saya ini tidak benar dan/atau tidak saya penuhi, saya bers edia mengembalikan seluruh subsidi yang telah saya terima dari Pemerintah dan bersedia dikenakan sanksi sesuai dengan ketentuan peraturan perundang-undangan.</p>
          <p>Memberikan persetujuan kepada Bank BTN untuk memberikan semua data pribadi saya yang terdapat di Bank BTN kepada PPDPP. Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
                width: "170px",
              }}
            >
              <div>
                Menyetujui, <br />
                Suami/Istri*
              </div>
            </div>
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
                width: "170px",
              }}
            >
              <div>
                Bogor, ................................
                <br />
                Yang membuat pernyataan,
              </div>
              <div
                style={{
                  marginTop: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                  Materai
                  <br />
                  10.000,-
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                width: "170px",
                textAlign: "center",
              }}
            >
              <div>{item.sls_appl?.name_spouse ?? "-"}</div>
            </div>
            <div
              style={{
                marginTop: "25px",
                width: "170px",
                textAlign: "center",
              }}
            >
              <div>{item.sls_appl?.name ?? "-"}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
